import React from "react";
import "./header.css";
import { Link } from "react-router-dom";

function Header() {
  return (
    <div className="HeaderContainer">
      <Link to="/">
      <div className="Logo"></div>
      </Link>
      
      <div className="MenuLink">
        <Link to="/pricelist">
          <div> Cennik </div>
        </Link>
      </div>
      <div className="MenuLink">
        <Link to="/portfolio">
          <div> Realizacje</div>
        </Link>
      </div>
      <div className="MenuLink">
        <Link to="/contact">
          <div> Kontakt</div>
        </Link>
      </div>
    </div>
  );
}

export default Header;
